import { Community } from '../../types';

export function getMyCommunitiesPath(userId: number | string, page: number): string {
    return `/communities/by-user/${userId}?page=${page}`;
}

export function getMyCommunitiesStorageKey(userId: number | string): string {
    return `myCommunities-v2-${userId}`;
}

export function mergeMyCommunitiesPage(
    previousCommunities: Community[],
    fetchedCommunities: Community[],
    page: number,
): Community[] {
    const baseCommunities = page === 1 ? [] : previousCommunities;
    const existingIds = new Set(baseCommunities.map(community => community.id));

    return [
        ...baseCommunities,
        ...fetchedCommunities.filter(community => !existingIds.has(community.id)),
    ];
}
